import { CurrentPractitioner } from './types';
import { useCurrentPractitionerGlobalState } from './useCurrentPractitionerGlobalState';

export const useGetCurrentPractitionerGlobalState = (): CurrentPractitioner => {
   const { getCurrentPractitioner } = useCurrentPractitionerGlobalState();
   const currentPractitioner = getCurrentPractitioner();

   /*
    * // TODO DREGAB-25028 Przeniesienie funkcjonalność integracji z Pharmindexem do panelu support
    * if (!currentPractitioner) {
    *    throw new Error('Use hook when initializing the application.');
    * }
    */

   return currentPractitioner!;
};
